function initNewsFilter(){
    $('.news-category a.active').tab('show');
    $('.news-category a').click(function (e) {
        e.preventDefault();
        $('.news-category a').removeClass('active');
        $(this).addClass('active');
        $(this).tab('show');
    })
}